<div class="gp-alert gp-alert-danger">
  <p>{{ 'UNSUPPORTED_BROWSER.MESSAGE' | translate }}</p>
  <p>
    <a [href]="'UNSUPPORTED_BROWSER.LINK' | translate">{{
      'LINK' | translate
    }}</a>
  </p>
</div>
